import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import MobileHeader from "../../../layout/OwnerLayout/Header";
import SearchBox from "./Components/SearchBox";
import CustomButton from "../../../components/CustomButton";
import ArrowLeftCircle from "../../../../media/images/icons/arrow-left-circle";
import { Filter } from "@mui/icons-material";
import FilterSVG from "../../../../media/images/icons/filter-icon";
import CompanyCard from "./Components/CompanyCardV2";

export default function CommonCarriers() {
  const [onfocuse, setOnFocuse] = useState();

  return (
    <>
      <MobileHeader
        title={
          <Typography variant="h5" color="secondary.main">
            شرکت های حمل{" "}
          </Typography>
        }
        hasScroll={false}
      />
      <Box
        sx={{
          flex: 1,
          // border: "1px solid gray",
          overflow: "auto",
          paddingX: "8px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            mt: 2,
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {/* <SearchBox /> */}
          {/* <CustomButton
            // loading={loading}
            // onClick={formik.handleSubmit}
            flexDirection="row"
            title="تنظیم فیلتر"
            justifyContent="center"
            bgColor="secondary.main"
            fSize="16px"
            px="10px"
            py="10px"
            borderRadius="10px"
            icon1={<FilterSVG size={16} />}
          /> */}
        </Box>

        <Box
          sx={{
            mt: 2,
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <CompanyCard />
          <CompanyCard />
          <CompanyCard />
          <CompanyCard />
        </Box>
      </Box>
    </>
  );
}
